export var getClosingPeriodPage = `query GetClosingPeriodPage($data: PaymentParameters) {
    GetClosingPeriodPage(data: $data) {
        results
        {
            ID
            PeriodGuid
            Period
            State
            StartDate
            EndDate
            AgencyGuid
            CreatedAt
            CreatedDate
            IsDefault
            PrevPeriodID
            ModifiedDate
            Timestamp
            ActorWiseClosedBalances
            {
                ID
                CreatedAt
                AppliedTo
                {
                    ActorID
                    ActorType
                }
                ClosingBalGuid
                CurrencyExchangeDate
                PeriodID
                AccountGuid
                CostCentreGuid
                CurrencyGuid
                IsActorSpecific
                Amount
                {
                    DebitAmount
                    CreditAmount
                    
                }
                PeriodAmount
                {
                    DebitAmount
                    CreditAmount                
                }
                PreviewAmount
                {
                    DebitAmount
                    CreditAmount                
                }
                Timestamp
                ModifiedDate
                OperationMode
                IsOpeningBalance
            }
        }
        pageCount
    }
  }`;